export default __webpack_public_path__ + "static/media/text-italic.9c9374fa.svg";